module.exports = __webpack_public_path__ + "static/img/bt.cdf4539.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/bt.png
// module id = +e96
// module chunks = 1